import React, { useState, useEffect } from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import DataTable from "aldoo-ra/DataTable"
import { NeedsCRUD, GetNeedsStats } from "./api"

function CategoryCard({ category, count, maxCount }) {
  const pct = maxCount > 0 ? Math.round((count / maxCount) * 100) : 0
  return (
    <div className="bg-admin_paper border border-admin_bordered rounded-lg p-4">
      <p className="text-xs text-admin_text_secondary mb-1 truncate">{category}</p>
      <p className="text-xl font-semibold text-admin_text mb-2">{count}</p>
      <div className="h-1.5 bg-admin_bordered rounded-full overflow-hidden">
        <div className="h-full bg-admin_primary rounded-full" style={{ width: `${pct}%` }} />
      </div>
    </div>
  )
}

export default function NeedsBrowser() {
  const [byCategory, setByCategory] = useState([])
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    GetNeedsStats().then((res) => {
      if (res.result) setByCategory(res.byCategory)
    })
  }, [refreshKey])

  const maxCount = byCategory.length > 0 ? byCategory[0].count : 0

  const columns = [
    {
      id: "sessionId",
      header: "Session",
      headerClassName: "w-[22%]",
      render: (v) => <span className="text-xs font-mono text-admin_text">{v?.slice(0, 20)}…</span>
    },
    {
      id: "agentId",
      header: "Agent",
      headerClassName: "w-[18%]",
      render: (v) => <span className="text-xs text-admin_text">{v}</span>
    },
    {
      id: "category",
      header: "Category",
      headerClassName: "w-[18%]",
      render: (v) => <span className="text-xs bg-admin_neutral_1 px-2 py-0.5 rounded">{v || "—"}</span>
    },
    {
      id: "need",
      header: "Need",
      headerClassName: "w-[30%]",
      render: (v) => <span className="text-xs text-admin_text">{v}</span>
    },
    {
      id: "createdAt",
      header: "Date",
      headerClassName: "w-[12%]",
      render: (v) => <span className="text-xs text-admin_text_secondary">{v ? new Date(v).toLocaleDateString() : "—"}</span>
    }
  ]

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <Typography variant="h2">Visitor Needs</Typography>
        <Button variant="secondary" size="sm" onClick={() => setRefreshKey((k) => k + 1)}>Refresh</Button>
      </div>

      {byCategory.length > 0 && (
        <div className="mb-6">
          <Typography variant="h4" className="mb-3">Top Categories</Typography>
          <div className="grid grid-cols-5 gap-3">
            {byCategory.slice(0, 10).map((c) => (
              <CategoryCard key={c.category} category={c.category} count={c.count} maxCount={maxCount} />
            ))}
          </div>
        </div>
      )}

      <DataTable
        refreshKey={refreshKey}
        renders={columns}
        apiMethod={NeedsCRUD.Get}
        requestFields={{}}
      />
    </div>
  )
}
